module.exports = __webpack_public_path__ + "img/qg.096355d8.webp";